import { render, staticRenderFns } from "./emailCodeRecode.vue?vue&type=template&id=d4f23f68"
import script from "./emailCodeRecode.vue?vue&type=script&lang=js"
export * from "./emailCodeRecode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports